module.exports = __webpack_public_path__ + "static/media/trionix.bcf9bffa.jpg";